import Samrat from "../image/stis.png";
import Marketing from "../image/smartcard.jpeg";
import Nestiva from "../image/nestiva.jpeg";

const projects = [
  {
    title: "Business Website",
    img: Samrat,
    link: "https://samrattechitsolutions.com/",
    description:
      "A modern IT solutions website showcasing hardware, software, networking, security, and digital services with a clean corporate design.",
  },
  {
    title: "Marketing Website",
    img: Marketing,
    link: "https://smartcard-site.netlify.app/",
    description:
      "A responsive eCommerce website featuring product browsing, shopping cart, wishlist, secure checkout, and an intuitive user experience.",
  },
  {
    title: "Medical Website",
    img: Nestiva,
    link: "https://stellar-pudding-bfbd5b.netlify.app/",
    description:
      "A premium healthcare website with doctor information, medical services, online appointment booking, and an AI-powered chatbot.",
  },
];

export default projects;